// 商品卡「新品」標籤的文字：個別商品可以換成更貼切的兩個字（例如慕斯上市一段時間，改標「必備」）
const NEW_BADGE_TEXT = { 100009: '必備' }
export function newBadgeText(productId) {
  return NEW_BADGE_TEXT[productId] || '新品'
}
